import { api } from '@api/queries/base';
import { combineReducers } from '@reduxjs/toolkit';

import appReducer from './reducers/appReducer';
import authReducer from './reducers/authReducer';
import bingoReducer from './reducers/bingoReducer';
import contractReducer from './reducers/contractReducer';
import diceGameReducer from './reducers/diceGameReducer';
import earnRewardsReducer from './reducers/earnRewardsReducer';
import factoryReducer from './reducers/factoryReducer';
import groupFriendsReducer from './reducers/groupFriendsReducer';
import leaguesReducer from './reducers/leaguesReducer';
import lotteryReducer from './reducers/lotteryReducer';
import modalsReducer from './reducers/modalsReducer';
import paymentReducer from './reducers/paymentsReducer';
import quarryReducer from './reducers/quarryReducer';
import scratchReducer from './reducers/scratchReducer';
import shopReducer from './reducers/shopReducer';
import tasksReducer from './reducers/tasksReducer';
import userReducer from './reducers/userReducer';
import workshopReducer from './reducers/workshopReducer';

const rootReducer = combineReducers({
  app: appReducer,
  auth: authReducer,
  user: userReducer,
  quarry: quarryReducer,
  tasks: tasksReducer,
  contract: contractReducer,
  factory: factoryReducer,
  groupFriends: groupFriendsReducer,
  workshop: workshopReducer,
  earnRewards: earnRewardsReducer,
  leagues: leaguesReducer,
  shop: shopReducer,
  diceGame: diceGameReducer,
  modals: modalsReducer,
  payment: paymentReducer,
  lottery: lotteryReducer,
  bingo: bingoReducer,
  scratch: scratchReducer,
  [api.reducerPath]: api.reducer,
});

export default rootReducer;
